export default function UserMenuOptions(
  userType,
  { sharedBrandSession = false } = {},
) {
  const type = String(userType || "").toLowerCase();
  const changePassword = {
    id: "password",
    buttonName: "Change password",
    buttonAction: "./account/password",
  };
  const yourCollection = {
    id: "collection",
    buttonName: "Your Collection",
    buttonAction: "./collection",
  };
  const collection = {
    id: "collection",
    buttonName: "Collection",
    buttonAction: "./collection",
  };
  const library = {
    id: "library",
    buttonName: "Library",
    buttonAction: "./library",
  };
  const addEdit = {
    id: "add-edit",
    buttonName: "Add/Edit Materials",
    buttonAction: "./material/add",
  };

  if (type === "vendoradmin") {
    return [
      yourCollection,
      library,
      addEdit,
      {
        id: "settings",
        buttonName: "Settings",
        buttonAction: "./settings",
      },
      changePassword,
    ];
  }

  if (type === "vendor") {
    return [
      yourCollection,
      library,
      addEdit,
      {
        id: "price",
        buttonName: "Price Update",
        buttonAction: "./material/price",
      },
      changePassword,
    ];
  }

  if (type === "designer") {
    const items = [
      collection,
      library,
      { id: "contact", buttonName: "Contact", buttonAction: "./contact" },
      { id: "help", buttonName: "help", buttonAction: "./help" },
    ];
    if (!sharedBrandSession) {
      items.push(changePassword);
    }
    return items;
  }

  if (type === "guest") {
    return [
      { id: "login", buttonName: "Login", buttonAction: "./" },
      { id: "contact", buttonName: "Contact", buttonAction: "./contact" },
      { id: "help", buttonName: "help", buttonAction: "./help" },
    ];
  }
}
